import React from "react";
import { useQuery } from "react-query";
import { tdsCompletePares } from "./gateway";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";

function useTdsCompletePares({
  enabled,
  merchantReference,
  setDialog3DSOpen,
  relatedId,
  relatedType,
}: {
  enabled: boolean;
  merchantReference: string;
  setDialog3DSOpen: React.Dispatch<React.SetStateAction<boolean>>;
  relatedId?: string;
  relatedType?: string;
}) {
  const navigate = useNavigate();
  return useQuery({
    queryFn: () => tdsCompletePares(merchantReference),
    queryKey: ["tdsCompletePares", merchantReference],
    enabled: enabled,
    onSuccess: (data) => {
      if (data?.data?.invoiceFileName) {
        setDialog3DSOpen(false);
        navigate("/cardPayment/successPayment", {
          state: {
            invoiceFileName: data?.data?.invoiceFileName,
            approvalCode: data?.data?.approvalCode,
            relatedId: relatedId,
            relatedType: relatedType,
          },
        });
      }
    },
    onError: (data: AxiosError<string>) => {
      setDialog3DSOpen(false);
      enqueueSnackbar(data?.response?.data, {
        variant: "error",
      });
    },
  });
}

export default useTdsCompletePares;
